import React, { useState, useEffect, useRef } from 'react';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';

import styled from 'styled-components/macro';
import FramiIconButton from './FramiIconButton';
import { useNavigation } from '../../context';

const Wrapper = styled.section`
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    gap: 8px;
    padding: ${(props) => props.$padding || '4px'};

    &::-webkit-scrollbar {
        display: none;
    }
`;

const isIOS = () => {
    if (typeof navigator === 'undefined') return false;
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  };

const ScrollHorizontalContainer = ({
    children,
    isMobile,
    selectedOptionIndex = null,
    scrollStep = 'clientWidth',
    scrollToSelectOnMount = false,
    padding,
}) => {
    const { activeDrawer } = useNavigation();
    const [canScroll, setCanScroll] = useState(false);
    const [showLeftArrow, setShowLeftArrow] = useState(false);
    const [showRightArrow, setShowRightArrow] = useState(false);

    const wrapperRef = useRef();

    useEffect(() => {
        const timer = setTimeout(() => {
            const current = wrapperRef.current;
            if (current) {
                setCanScroll(current.scrollWidth > current.clientWidth);
            }
        }, 300);

        return () => clearTimeout(timer);
    }, [activeDrawer, isMobile, children]);

    useEffect(() => {
        if (scrollToSelectOnMount && selectedOptionIndex) {
            const optionWidth = wrapperRef.current.lastChild.offsetWidth;
            const newScrollPosition = selectedOptionIndex * optionWidth;

            wrapperRef.current.scrollTo({
                left: newScrollPosition,
                behavior: 'smooth',
            });
        }
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const wrapper = wrapperRef.current;
            if (wrapper) {
                const maxScroll = wrapper.scrollWidth - wrapper.clientWidth;
                setShowLeftArrow(wrapper.scrollLeft > 0);
                setShowRightArrow(wrapper.scrollLeft < maxScroll - 1);
            }
        };

        const wrapper = wrapperRef.current;
        wrapper.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => {
            wrapper.removeEventListener('scroll', handleScroll);
        };
    }, [activeDrawer, children]);

    const handleScroll = (direction) => {
        let step;
        if (scrollStep === 'clientWidth') {
            step = wrapperRef.current.clientWidth * 0.8;
        } else if (scrollStep === 'childrenWidth') {
            step = wrapperRef.current.lastChild.offsetWidth + 30;
        }
        wrapperRef.current.scrollBy({ left: direction === 'left' ? -step : step, behavior: 'smooth' });
    };

    return (
        <div className={`scroll-horizontal-container ${isIOS() ? 'ios' : ''}`} style={{ zIndex: 1 }}>

            {canScroll && wrapperRef.current && (
                <>
                    {showLeftArrow && (
                        <FramiIconButton
                            className={'scroll-horizontal-arrow left'}
                            icon={<MdKeyboardArrowLeft size={20}/>}
                            onClick={() => handleScroll('left')}
                        />
                    )}
                    {showRightArrow && (
                        <FramiIconButton
                            className={'scroll-horizontal-arrow right'}
                            icon={<MdKeyboardArrowRight size={20} />}
                            onClick={() => handleScroll('right')}
                        />
                    )}
                </>
            )}
            <Wrapper $isMobile={isMobile} ref={wrapperRef} $padding={padding}>
                {children}
            </Wrapper>
        </div>
    );
};

export default ScrollHorizontalContainer;
